import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import logo_pop from '../assets/images/logo-pop.png';
import * as globals from '../globals.js';
import ApiService from '../services/ApiService';
import NotificationService from '../services/NotificationService';
import IntegerInput from '../components/IntegerInput';
import FilteredInput from '../components/FilteredInput';
import InputMask from 'react-input-mask';
import EDSFooter from '../components/EDSFooter';
import { useSelector } from 'react-redux';

const Rejestracja_dane = () => {
    const apiService = ApiService.getInstance();
    const notificationService = NotificationService.getInstance();
    const history = useHistory();
    const [dateofbirdth, setdateofbirdth] = useState();
    const key = useSelector((state) => state.repos.chName);

    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        genderDVID: '',
        dateofbirdth: '',
        pesel: '',
        street: '',
        building: '',
        flat: '',
        city: '',
        postalCode: '',
        email: '',
        phone: '',
        personalDataProcessingConsent: '',
        currentPurchaseKey: key
    });

    const formValid = () => {
        if (!/[0-9]{9}$/.test(formData.phone)) {
            notificationService.showError('Nieprawidłowy numer Telefonu');
            return false;
        }
        if (formData.pesel.length !== 11) {
            notificationService.showError('Nieprawidłowy numer PESEL');
            return false;
        }
        if (!/^\d{2}(?:[-\s]\d{3})?$/.test(formData.postalCode)) {
            notificationService.showError('Nieprawidłowy kod pocztowy');
            return false;
        }
        if (!/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$/.test(formData.email)) {
            notificationService.showError('Nieprawidłowy adres E-Mail');
            return false;
        } else {
            return true;
        }
    };

    function parsePesel(id) {
        setFormData(formData.pesel = id);
        let pesel = id.toString().replace(/[^0-9]/g, "")
        let peselN = pesel;
        if (peselN.toString().length === 11) {
            let rr = '';
            let mm = '';
            let dd = '';
            let rok;
            for (let i = 0; i < peselN.toString().length; i++) {
                if (i <= 1) {
                    rr += peselN[i];
                }
                if (i > 1 && i <= 3) {
                    mm += peselN[i];
                }
                if (i > 3 && i <= 5) {
                    dd += peselN[i];
                }
            }
            if (Number(peselN[2]) === 0 || Number(peselN[2]) === 1) {
                rok = 19 + rr;
            }
            if (Number(peselN[2]) === 2 || Number(peselN[2]) === 3) {
                rok = 20 + rr;
            }
            if (Number(peselN[2]) === 2 || Number(peselN[2]) === 3) {
                rok = 20 + rr;
            }
            if (Number(mm[0]) !== 1) {
                if (Number(mm[0]) === 2) {
                    let numM = mm[0];
                    numM = 0 + mm[1];
                    mm = numM;
                }
                if (Number(mm[0]) === 3) {
                    let numM = mm[0];
                    numM = 1 + mm[1];
                    mm = numM;
                }
            }
            let dateOfBirdth = rok + '-' + mm + '-' + dd;
          
            if (dateOfBirdth && dateOfBirdth !== 'Invalid Date') {
                setFormData({...formData, ...{dateOfBirdth: dateOfBirdth.toString()}})
                setdateofbirdth( dd + '-' + mm + '-' + rok)
            }
        }else {
            setFormData({...formData, ...{dateOfBirdth: ''}})
            setdateofbirdth('')
        }
    }

    const save = (e) => {
        e.preventDefault();

        const error = (msg = null) => {
            if (typeof msg === 'string' && msg.length > 0) {
                notificationService.showError(msg);
            } else {
                notificationService.showError();
            }
            // history.push('/rejestracja_error');
        };

        if (formValid()) {
            apiService.apiPost(
                'CheckUserForRegistrationStatus',
                formData,
                (response) => {
                    if (response.success) {
                        const messageTxt = globals.getRegistrationTextByStatus(
                            response.data.message
                        );
                        if (response.data.message == 'strUserRegistered') {
                            history.push('/rejestracja_potwierdzenie');
                        } else {
                            if (response.data.message == 'strLoginUpdated') {
                                history.push('/');
                            } else {
                                error(messageTxt);
                            }
                        }
                    } else {
                        error();
                    }
                },
                false
            );
        }
    };

    return (
        <>
            <header className="header">
                <div className="header__image-box">
                    <a href="">
                        <img
                            src={logo_pop}
                            alt="Logo Egurrola Dance Studio"
                            className="header__image"
                        />
                    </a>
                </div>

                <div className="header__caption-box">
                    <span className="header__caption">Proces zakupu kursu</span>
                </div>
            </header>

            <div className="content">
                <main className="registration responsive-padding">
                    <div className="text-box margin-top-64">
                        <h2 className="h2">Załóż konto</h2>
                        {/* <p className="text-regular margin-top-16">
                            Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut
                            fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem
                            sequi nesciunt. Neque porro quisquam est.
                        </p> */}
                    </div>

                    <form
                        id="registration-form"
                        className="form"
                        method="post"
                        action=""
                        onSubmit={(e) => save(e)}
                    >
                        <div className="form__row">
                            <label htmlFor="fname" className="form__label">
                                Imię<sup> *</sup>
                            </label>
                            <input
                                type="text"
                                name="fname"
                                id="fname"
                                className="form__input"
                                title="Wpisz swoję imię"
                                onChange={(e) =>
                                    setFormData({ ...formData, ...{ firstName: e.target.value } })
                                }
                                required
                            />
                        </div>

                        <div className="form__row">
                            <label htmlFor="lname" className="form__label">
                                Nazwisko<sup> *</sup>
                            </label>
                            <input
                                type="text"
                                name="lname"
                                id="lname"
                                className="form__input"
                                title="Wpisz swoję nazwisko"
                                onChange={(e) =>
                                    setFormData({ ...formData, ...{ lastName: e.target.value } })
                                }
                                required
                            />
                        </div>

                        <div className="form__row">
                            <fieldset>
                                <legend className="form__legend">
                                    Płeć<sup> *</sup>
                                </legend>

                                <div className="radio-group">
                                    <input
                                        type="radio"
                                        name="gender"
                                        id="gender-female"
                                        className="form__radio"
                                        value="Kobieta"
                                        onChange={(e) =>
                                            setFormData({ ...formData, ...{ genderDVID: 2 } })
                                        }
                                        required
                                    />
                                    <label htmlFor="gender-female" className="form__label--radio">
                                        Kobieta
                                    </label>

                                    <input
                                        type="radio"
                                        name="gender"
                                        id="gender-male"
                                        className="form__radio"
                                        value="Mężczyzna"
                                        onChange={(e) =>
                                            setFormData({ ...formData, ...{ genderDVID: 1 } })
                                        }
                                    />
                                    <label htmlFor="gender-male" className="form__label--radio">
                                        Mężczyzna
                                    </label>
                                </div>
                            </fieldset>
                        </div>

                        <div className="form__row">
                            <label htmlFor="pesel" className="form__label">
                                PESEL<sup> *</sup>
                            </label>

                            <InputMask
                                className="form__input"
                                title="Podaj PESEL"
                                name="pesel"
                                mask="99999999999"
                                maskChar="_"

                                onChange={(e) =>

                                   
                                    parsePesel(e.target.value)
                                }
                                required
                            ></InputMask>
                        </div>


                        {/* <div className="form__row">
                            <label htmlFor="pesel" className="form__label">
                                PESEL<sup> *</sup>
                            </label>

                            <InputMask
                                className="form__input"
                                title="Podaj PESEL"
                                name="pesel"
                                mask="99999999999"
                                maskChar="_"
                                onChange={(e) => {
                                    setFormData({ ...formData, ...{ pesel: e.target.value } });
                                }}
                                required
                            ></InputMask>
                        </div> */}
                        <div className="form__row">
                            <label htmlFor="bday" className="form__label">
                                Data urodzenia (DD.MM.RRRR)<sup> *</sup>
                            </label>
                            <input
                                type="text"
                                name="bday"
                                id="bday"
                                className="form__input"
                                title="Podaj datę urodzenia"
                                min="1900-01-01"
                                max="2100-12-31"
                                // onChange={(e) =>
                                //     setFormData({
                                //         ...formData,
                                //         ...{ dateofbirdth: e.target.value },
                                //     })
                                // }
                                value={dateofbirdth}
                                disabled={true}
                            // required
                            />
                        </div>
                        {/* <div className="form__row">
                            <label htmlFor="bday" className="form__label">
                                Data urodzenia (dd-mm-rrrr)<sup> *</sup>
                            </label>
                            <input
                                type="date"
                                name="bday"
                                id="bday"
                                className="form__input"
                                title="Podaj datę urodzenia"
                                min="1900-01-01"
                                max="2100-12-31"
                                onChange={(e) =>
                                    setFormData({
                                        ...formData,
                                        ...{ dateofbirdth: e.target.value },
                                    })
                                }
                                required
                            />
                        </div> */}

                        <div className="form__row">
                            <label htmlFor="street" className="form__label">
                                Ulica<sup> *</sup>
                            </label>
                            <input
                                type="text"
                                name="street"
                                id="street"
                                className="form__input"
                                title="Podaj nazwę ulicy"
                                onChange={(e) =>
                                    setFormData({ ...formData, ...{ street: e.target.value } })
                                }
                                required
                            />
                        </div>

                        <div className="form__row form__row--home-numbers">
                            <div>
                                <FilteredInput
                                    label={'Nr domu'}
                                    fieldName={'house'}
                                    title={'Podaj numer domu'}
                                    textMode={true}
                                    timeoutEnabled={false}
                                    onChange={(val) => {
                                        setFormData({
                                            ...formData,
                                            ...{ building: val },
                                        });
                                    }}
                                    charCodeFilter={(charCode) => {
                                        if (
                                            // numbers
                                            (charCode >= 48 && charCode <= 57) ||
                                            // capital letters
                                            (charCode >= 65 && charCode <= 90) ||
                                            // small letters
                                            (charCode >= 97 && charCode <= 122)
                                        ) {
                                            return true;
                                        } else return false;
                                    }}
                                    required={true}
                                ></FilteredInput>
                            </div>

                            <div>
                                <FilteredInput
                                    label={'Nr mieszkania'}
                                    fieldName={'flat'}
                                    title={'Podaj numer mieszkania'}
                                    textMode={true}
                                    timeoutEnabled={false}
                                    onChange={(val) => {
                                        setFormData({
                                            ...formData,
                                            ...{ flat: val },
                                        });
                                    }}
                                    charCodeFilter={(charCode) => {
                                        if (
                                            // numbers
                                            (charCode >= 48 && charCode <= 57) ||
                                            // capital letters
                                            (charCode >= 65 && charCode <= 90) ||
                                            // small letters
                                            (charCode >= 97 && charCode <= 122)
                                        ) {
                                            return true;
                                        } else return false;
                                    }}
                                    required={false}
                                ></FilteredInput>
                            </div>
                        </div>

                        <div className="form__row">
                            <label htmlFor="city" className="form__label">
                                Miejscowość<sup> *</sup>
                            </label>
                            <input
                                type="text"
                                name="city"
                                id="city"
                                className="form__input"
                                title="Podaj miasto"
                                onChange={(e) =>
                                    setFormData({ ...formData, ...{ city: e.target.value } })
                                }
                                required
                            />
                        </div>

                        <div className="form__row">
                            <label htmlFor="zipcode" className="form__label">
                                Kod pocztowy<sup> *</sup>
                            </label>

                            <InputMask
                                className="form__input"
                                title="Podaj kod pocztowy"
                                name="zipcode"
                                mask="99-999"
                                maskChar="_"
                                onChange={(e) => {
                                    setFormData({ ...formData, ...{ postalCode: e.target.value } });
                                }}
                                required
                            ></InputMask>
                        </div>

                        <div className="form__row">
                            <label htmlFor="mail" className="form__label">
                                E-mail<sup> *</sup>
                            </label>

                            <input
                                type="email"
                                name="mail"
                                id="mail"
                                className="form__input"
                                title="Podaj e-mail"
                                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$"
                                onChange={(e) =>
                                    setFormData({ ...formData, ...{ email: e.target.value } })
                                }
                                required
                            />
                        </div>

                        <div className="form__row">
                            <IntegerInput
                                label={'Nr telefonu'}
                                fieldName={'phone'}
                                title={'Podaj nr telefonu'}
                                min={0}
                                max={999999999}
                                textMode={true}
                                timeoutEnabled={false}
                                onChange={(val) => {
                                    setFormData({ ...formData, ...{ phone: val } });
                                }}
                                required={true}
                                allowEmptyValue={true}
                            ></IntegerInput>
                        </div>

                        <div className="form__row">
                            <p className="checkbox-group">
                                <input
                                    type="checkbox"
                                    id="agreement"
                                    name="agreement"
                                    className="form__checkbox"
                                    onChange={(e) =>
                                        setFormData({
                                            ...formData,
                                            ...{ personalDataProcessingConsent: 1 },
                                        })
                                    }
                                    required
                                />
                                <label
                                    htmlFor="edit-related-agreement"
                                    className="form__label--checkbox consent_checkbox"
                                >
                                    <div>Akceptuję Klauzulę informacyjną RODO:</div>
                                    <ul>
                                        {globals.USER_CONSENTS.map((consent) => (
                                            <li>{consent}</li>
                                        ))}
                                    </ul>
                                </label>
                            </p>
                            <p className="checkbox-group">
                                <input
                                    type="checkbox"
                                    id="regulations"
                                    name="regulations"
                                    className="form__checkbox"
                                    required
                                />
                                <label htmlFor="regulations" className="form__label--checkbox">
                                    Akceptuję{' '}
                                    <a
                                        href={globals.TERMS_URL}
                                        className="text-link"
                                        target="_blank"
                                        rel="noopener"
                                    >
                                        Regulamin
                                    </a>
                                </label>
                            </p>
                        </div>

                        <input
                            type="submit"
                            className="btn-primary margin-top-32 margin-bottom-32"
                            value="Zatwierdź"
                        />
                    </form>
                </main>
            </div>
            <EDSFooter></EDSFooter>
        </>
    );
};
export default Rejestracja_dane;
